import React, { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { API } from "../../../../../config/api";
import LoaderHome from "../../../../Loader/LoaderHome"

import swal from "sweetalert";


export default function ModalKalkulusIndex({ showModal, setShowModal, selectedTooth, positionTooth, onDataChange, setDebrisPerTooth, visibleOdontogram, setVisibleOdontogram, onSave }) {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pages, setPages] = useState();
    const [ascending] = useState(0);
    const [rows, setRows] = useState(1);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");
    const [msg, setMsg] = useState("");
    const token = localStorage.getItem("token");
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);


    const [selectedKalkulus, setSelectedKalkulus] = useState([]);


    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };

    const [getDataKalkulusIndex, setGetDataKalkulusIndex] = useState([]);


    const GetResponseDataKalkulusIndex = async () => {
        try {
            setLoading(true);
            const response = await API.get(`/emr-service/calculus-index?page=${page}&limit=${limit}&ascending=${ascending}`, fetchParams);
            if (response?.status === 200) {
                const kalkulusData = response.data.data;
                setGetDataKalkulusIndex(kalkulusData);
                setLoading(false);

                // Kirim semua data ke parent
                if (onDataChange) {
                    onDataChange(kalkulusData);
                }
            }
        } catch (error) {
            setLoading(false);
            swal({
                title: 'Failed',
                text: `${error.response?.data?.message || 'Something went wrong'}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    };


    useEffect(() => {
        GetResponseDataKalkulusIndex()
    }, [page])


    const handleSelectKalkulus = (item) => {
        if (!item || !item?.id) return;

        const toothPosition = positionTooth?.[selectedTooth] || null;

        setSelectedKalkulus((prev) => {
            const exists = prev?.some((d) => d?.id === item?.id);
            if (exists) {
                return prev?.filter((d) => d?.id !== item?.id);
            }

            return [
                ...prev,
                {
                    ...item,
                    position: toothPosition, 
                },
            ];
        });
    };

    const handlePilih = () => {
        if (onSave) onSave(selectedKalkulus); 
        setShowModal(false);
    };


    return (
        <>

            {loading && <LoaderHome />}

            {/* Modal tampil ketika polygon diklik */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Modal.Header closeButton className="bg-info text-white">
                    <Modal.Title>Debris Index Gigi {selectedTooth}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {getDataKalkulusIndex && getDataKalkulusIndex.length > 0 ? (
                        getDataKalkulusIndex.map((item, index) => (
                            <Button
                                key={index}
                                variant={
                                    Array.isArray(selectedKalkulus) && selectedKalkulus?.some((d) => d.id === item.id)
                                        ? "info"
                                        : "outline-info"
                                }
                                size="sm"
                                className="m-1"
                                onClick={() => handleSelectKalkulus(item)}
                            >
                                {item.display_name}
                            </Button>
                        ))
                    ) : (
                        <p className="text-muted">Tidak ada data Kalkulus Index</p>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" className="btn-sm" onClick={() => setShowModal(false)}>
                        Batal
                    </Button>
                    <Button
                        variant="info"
                        size="sm"
                        onClick={handlePilih}
                        disabled={!Array.isArray(selectedKalkulus) || selectedKalkulus.length === 0}
                    >
                        Pilih
                    </Button>

                </Modal.Footer>
            </Modal>

        </>
    )
}